import React, { Component } from 'react'
import { AppContext } from '@lightspeed-invoicing/core-client/frontend'
import {defineMessages, FormattedMessage, injectIntl} from 'react-intl'
import $ from 'jquery'
import Select from "react-select";
import QuoteDeclinedReasonLabel from "./declinedreason.component.jsx";
import EventBus from "../../common/EventBus.js";
import ActionButton from "../../common/button/actionbutton.component.jsx";


const messages = defineMessages({
    "choose": {
        id: 'quote.declined_reason_modal.choose',
        defaultMessage: 'Select a lost reason',
    },
    "notes_placeholder": {
        id: 'quote.declined_reason_modal.notes_placeholder',
        defaultMessage: 'Additional notes about the lost reason...',
    },
})

class QuoteDeclinedReasonModal extends Component {

    constructor(props, context) {
        super(props, context);

        this.state = {
            selectedOption: null,
            notes: '',
            quoteId: this.props.quoteId,
        }

        this.onClose = this.props.onClose
        this.onSubmit = this.props.onSubmit

        this.handleChange = this.handleChange.bind(this)
        this.handleFormChange = this.handleFormChange.bind(this)
        this.closeModals = this.closeModals.bind(this)
        this.lost = this.lost.bind(this)
    }

    componentDidMount() {
        $('#declinedReasonModal').modal('show')
    }

    componentWillReceiveProps(nextProps, nextContext) {
        this.setState({
            quoteId: nextProps.quoteId || '',
        })
    }

    lost(event) {
        event.preventDefault()
        return AppContext.getApiClient().post('/quotes/' + this.state.quoteId + '/decline', {
            reason: this.state.selectedOption ? this.state.selectedOption.value : '',
            notes: this.state.notes,
        }).then(q => {
            EventBus.dispatch(EventBus.TopicQuoteDeclined, {
                quote: q,
            })
            $('#declinedReasonModal').modal('hide')
            this.onSubmit(q)
        })
    }

    closeModals(event, response) {
        event.preventDefault()
        $('#declinedReasonModal').modal('hide')
        this.onClose(response)
    }

    handleChange(selectedOption) {
        this.setState({
            selectedOption: selectedOption,
        })
    }

    handleFormChange(event) {
        const target = event.target;
        this.setState({
            [target.name]: target.value
        })
    }

    render() {

        return (
            <div>
                {/************** Discount quote Modal ***************/}
                <div className="modal fade"
                    id="declinedReasonModal"
                    role="dialog"
                    aria-hidden="true"
                    data-backdrop="static"
                    data-keyboard="false"
                >
                    <div className="modal-dialog modal-dialog-centered modal-lg" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title pb-0 mb-0 border-0" id="setDiscountModalLabel">
                                    <FormattedMessage
                                        id="quote.declined_reason_modal.title"
                                        defaultMessage="Lost reason"
                                    />
                                </h5>
                                <button type="button" className="close" onClick={this.closeModals} aria-label="Close">
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>

                            <div className="modal-body">
                                <div className="container-fluid">
                                    <div className="form-group row mb-3">
                                        <label className="col-12 col-md-2  col-form-label custom-form-label pb-2" htmlFor="notes">
                                            <FormattedMessage
                                                id="quote.declined_reason_modal.reason"
                                                defaultMessage="Lost reason"
                                            />
                                        </label>
                                        <div className="col-12 col-md-10">
                                            <Select
                                                placeholder={this.props.intl.formatMessage(messages["choose"])}
                                                value={this.state.selectedOption}
                                                onChange={this.handleChange}
                                                options={[
                                                    'made-an-updated-offer',
                                                    'too-expensive',
                                                    'bought-somewhere-else',
                                                    'not-interested',
                                                    'not-ready-to-buy',
                                                    'too-long-delivery-time',
                                                ].map(reason => {
                                                    return {
                                                        value: reason,
                                                        label: <QuoteDeclinedReasonLabel value={reason} />
                                                    }
                                                })}
                                                clearable={false}
                                            />
                                        </div>
                                    </div>
                                    <div className="form-group row mb-3">
                                        <label className="col-12 col-md-2  col-form-label custom-form-label pb-2" htmlFor="notes">
                                            <FormattedMessage
                                                id="quote.declined_reason_modal.notes"
                                                defaultMessage="Notes"
                                            />
                                        </label>
                                        <div className="col-12 col-md-10">
                                            <textarea
                                                className="form-control"
                                                id="notes"
                                                name="notes"
                                                onChange={this.handleFormChange}
                                                rows={5}
                                                placeholder={this.props.intl.formatMessage(messages["notes_placeholder"])}
                                            />
                                        </div>
                                    </div>

                                </div>
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-secondary" onClick={this.closeModals}>
                                    <FormattedMessage
                                        id="quote.declined_reason_modal.close_btn"
                                        defaultMessage="Close"
                                    />
                                </button>
                                <ActionButton disabled={!this.state.selectedOption} type="button" className="btn btn-danger" onClick={this.lost}>
                                    <FormattedMessage
                                        id="quote.declined_reason_modal.lost_btn"
                                        defaultMessage="Close lost"
                                    />
                                </ActionButton>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default  injectIntl(QuoteDeclinedReasonModal)





// WEBPACK FOOTER //
// ./src/quote/analytics/declinedreasonmodal.component.jsx